/* istanbul ignore file */
import React from 'react';

import { Suspense } from '@lumapps/lumx-suspense/components/Suspense';

import { SpaceSearchFieldProps } from './components/SpaceSearchField/SpaceSearchField';

const LazySpaceSearchField = React.lazy(async () => {
    const resolved = await import(
        /* webpackChunkName: 'space-search-field' */
        './components/SpaceSearchField/SpaceSearchField'
    );

    return { default: resolved.SpaceSearchField };
});

const SpaceSearchField = (props: SpaceSearchFieldProps) => (
    <Suspense loadingFallback={null}>
        <LazySpaceSearchField {...props} />
    </Suspense>
);

export { SpaceSearchField };
